const Invoice: React.FC<React.SVGProps<SVGSVGElement>> = props => {
  return (
    <svg
      width="33"
      height="31"
      viewBox="0 0 33 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={props.className ?? ''}>
      <path
        d="M3.55921 0.25V20.5H0.125V25.5625C0.125 28.3536 2.43622 30.625 5.27632 30.625H27.5987C30.4233 30.625 32.75 28.3384 32.75 25.5625V0.25H3.55921ZM6.99342 3.625H29.3158V25.5625C29.3158 26.516 28.5689 27.25 27.5987 27.25C26.6508 27.25 25.8816 26.4923 25.8816 25.5625V20.5H6.99342V3.625ZM10.4276 7V10.375H13.8618V7H10.4276ZM17.2961 7V10.375H25.8816V7H17.2961ZM10.4276 13.75V17.125H13.8618V13.75H10.4276ZM17.2961 13.75V17.125H25.8816V13.75H17.2961ZM3.55921 23.875H22.4474V25.5625C22.4474 26.1531 22.5519 26.7218 22.7425 27.25H5.27632C4.33019 27.25 3.55921 26.4923 3.55921 25.5625V23.875Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default Invoice;
